/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';

export const verifyEmailAndSendOTP = async (data: {
  email?: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.verifyEmailAndSendOTP}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};

export const resendForgotPasswordOTP = async (data: {
  email?: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.resendForgotPasswordOTP}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};

export const verifyForgotPasswordOTP = async (data: {
  email: string;
  password: string;
  otp: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.verifyForgotPasswordOTP}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};

export const verifyAndChangePassword = async (data: {
  email: string;
  password: string;
  otp: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.verifyAndChangePassword}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};
